import * as React from 'react';

import * as styles from './OnlineStatus.css';

export const OnlineStatus: React.FC = () => {
  return <span className={styles['status']}>Напишите, пока пользователь в сети</span>;
};
